import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat)
dayjs.extend(utc)

let enable_submit

function FileUploadDisplay({frmid, frmdataId, stepdata, uploads})
{
    if ( ! stepdata ) return
    if ( ! stepdata.datakeys ) return
    const key = stepdata.datakeys[0]
    return (
	<>
	    <div className="mb-3">
		<div class="p-2 d-flex align-items-center justify-content-between">
		    <div>{stepdata.stepno - 1}. {key}</div>
		    <div style={{fontSize: '0.8rem'}}>
			{dayjs(stepdata.updated_dt).format('D MMM YYYY HH:mm:ss')}
		    </div>
		</div>
		<hr className="m-1"/>
		{uploads.upload_details.map(detail => {
		    if ( detail.content_type.startsWith('image/') ) {
			return <img src={`/formupload/${frmid}/${frmdataId}/${stepdata.stepno}/${detail.name}/`}
				    className="w-100 img-fluid"/>
		    } else {
			return <div class="p-2 fs-6">{detail.name}</div>
		    }
		})}
		<hr className="m-1"/>
	    </div>
	</>
    )
}

function DefaultDisplay({frmid, frm, stepdata})
{
    if ( ! stepdata ) return
    return stepdata.datakeys.map((key, ki) => {
	const step = frm.steps[stepdata.stepno]
	return (
	    <div className="mb-3">
		<div class="p-2 d-flex align-items-center justify-content-between">
		    <div className="d-flex align-items-center" style={{color: step.btnColor}}>
			<div className="me-2">{stepdata.stepno - 1}.</div>
			<span className="material-symbols-outlined me-2">
			    {step.icon}
			</span>
			<div className="me-2">{key}</div>
		    </div>
		    <div style={{fontSize: '0.8rem'}}>
			{dayjs(stepdata.updated_dt).format('D MMM YYYY HH:mm:ss')}
		    </div>
		</div>
		<hr className="m-1"/>
		<div class="p-2 fs-6">{stepdata.formdata[key]}</div>
		<hr className="m-1"/>
	    </div>
	)})
}

function ThankYou({frmid, stepno, showSummary, summaryFormat, frmdataId})
{
    const [dataset, setDataset] = useState(null),
	  onLoadHandler = ev => {
	  }
    useState(() => {
	window.onload = onLoadHandler
	return window.removeEventListener('load', onLoadHandler)
    }, [])
    useEffect(() => {
	if ( showSummary ) {
	    fetch(`/pub/values/${frmid}/${frmdataId}/`)
		.then(r => r.ok ? r.json() : Promise.reject(r))
		.then(json => {
		    setDataset(json)
		})
		.catch(r => {
		})
	}
    }, [frmid])
    if ( ! dataset ) return
    return (
	<>
	    <div class="card">
		{dataset.data.map((stepdata, si) => {
		    if ( ! stepdata.datakeys ) return ''
		    switch(stepdata.steptype) {
		    case 'FileUpload':
			const uploads = dataset.uploads.find(x => x.stepno == stepdata.stepno)
			return <FileUploadDisplay frmid={frmid}
						  frm={dataset.frm}
						  frmdataId={frmdataId}
						  stepdata={stepdata}
						  uploads={uploads}/>;
		    default:
			return <DefaultDisplay frmid={frmid}
					       frm={dataset.frm}
					       stepdata={stepdata}/>
		    }
		})}
	    </div>
	</>
    )
}

(function() {
    const rootId = document.currentScript.getAttribute('data-rootid'),
	  el = document.getElementById(rootId),
	  stepId = el.getAttribute('data-stepid'),
	  showSummary = el.getAttribute('data-show-summary'),
	  summaryFormat = el.getAttribute('data-summary-format'),
	  frmdataId = el.getAttribute('data-frmdataid'),
	  handler = ev => {
	      if ( 'enable_submit' in window ) window.enable_submit(stepId, true)
	      else {
		  console.error('no "enable_submit" in window')
	      }
	  }
    if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", handler);
    } else {
	handler();
    }
    createRoot(el).render(<ThankYou frmid={el.getAttribute('data-frmid')}
				    stepno={el.getAttribute('data-stepno')}
				    showSummary={showSummary === 'True'}
				    summaryFormat={summaryFormat}
				    frmdataId={frmdataId}/>);
})();
